export default __webpack_public_path__ + "static/media/philly.de8c01a9.jpg";